import { generateToken } from '@/adapters/token';
import { IGenerateToken } from '@/interfaces/token';
import { getQueryParam } from '@/utilities/queryUtils';
import { useMutation } from '@tanstack/react-query';
import { isNil } from 'lodash';
import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

const Portal: React.FC = () => {
  const navigate = useNavigate();

  // Memoize query parameters to prevent unnecessary re-renders
  const queryParams = useMemo(
    () => ({
      route: getQueryParam('r'),
      server: getQueryParam('s'),
      username: getQueryParam('u'),
      si: getQueryParam('si'),
    }),
    []
  );

  const { route, server, username, si } = queryParams;

  // Mutation hook to handle token generation
  const { mutate, isPending, isError } = useMutation({
    mutationFn: async (req: IGenerateToken) => generateToken(req),
    mutationKey: ['generate-token'],
    onSuccess: (data) => {
      if (data.status === 200 && data?.data?.token) {
        navigate(`/${route}?token=${data.data.token}`);
      }
    },
    onError: (error) => {
      console.error('Token generation failed:', error);
    },
  });

  useEffect(() => {
    if (route && server && username && si) {
      mutate({ role: 'user', serverCode: server, site: si, username });
    }
  }, [route, server, username, si, mutate]);

  if (isNil(route) || isNil(server) || isNil(username) || isNil(si)) {
    return <h2 className="text-center">Not found</h2>;
  }

  if (isPending) {
    return <h2 className="text-center">Loading...</h2>;
  }

  if (isError) {
    return <h2 className="text-center text-red-500">Error generating token</h2>;
  }

  return null;
};

export default Portal;
